import React, { useEffect, useState } from "react";
import "./index.css";

type LevelBarProps = {
  className?: string;
  percent: number;
  label?: string;
};

function LevelBar({ className, percent, label }: LevelBarProps) {
  const [num, setNum] = useState(0); // 1~5

  useEffect(() => {
    const newNum = Math.ceil(percent / 20); 
    setNum(newNum);
  }, [percent]);

  return (
    <div className="LevelBar__wrap">
      {Array.from({ length: num }).map((_, index) => (
        <div
          key={index}
          className={`LevelBar__box ${index===0?'LevelBar__leftBox':index===4?'LevelBar__rightBox':null} ${className}`} 
        />
      ))}
      {Array.from({ length: 5-num }).map((_, index) => (
        <div
          key={num+index}
          className={`LevelBar__box LevelBar__empty ${index+num===0?'LevelBar__leftBox':index+num===4?'LevelBar__rightBox':null}`} 
        />
      ))}
      <div className="LevelBar__percent">{label ? label : percent.toFixed(1) + '%'}</div>
    </div>
  );
}

export default LevelBar;
